import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { FixaCommercialMessage } from "@coworker/apprestructured/src/shared/wrappers/FixaCommercialMessage/FixaCommercialMessage";
import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import styled, { css } from "styled-components";
import { FurnitureSetWrapper } from "../Atoms/FurnitureSetWrapper";

export const ListWrapper = styled.div`
  width: 100%;
  flex-grow: 1;
`;

export const GreyListWrapper = styled.div`
  width: 100%;
  flex-grow: 1;
  background-color: var(--grey100);
`;

export const ListItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 24px;
`;

export const LeftContainer = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CenterContainer = styled.div<{ $centerText: boolean }>`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: ${({ $centerText }) => ($centerText ? "center" : "left")};
  text-align: ${({ $centerText }) => ($centerText ? "center" : "left")};
`;

export const CenterContainerWithGap = styled.div<{ $centerText: boolean }>`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: ${({ $centerText }) => ($centerText ? "center" : "left")};
  text-align: ${({ $centerText }) => ($centerText ? "center" : "left")};
  gap: 10px;
`;

export const RightContainer = styled.div`
  flex-grow: 0;
`;

export const SizedText = styled.div<{ $fontSize: number; $bold?: boolean }>`
  font-size: ${({ $fontSize }) => $fontSize}px;
  font-weight: ${({ $bold }) => ($bold ? "bold" : "normal")};
`;

export const Overlay = styled.div`
  position: relative;
  ${({ minHeight }: { minHeight: string }) => css`
    min-height: ${minHeight};
  `}
  max-width: 100%;

  svg {
    position: absolute;
    max-width: 100%;
    top: 0;
    left: 0;
  }
`;

export const ListItemWrapper = styled.div<{ $hasBanner: boolean }>`
  display: flex;
  flex-direction: column;
  box-shadow: 1px 0px 0px 1px var(--grey200);
  padding: 24px;
  gap: ${({ $hasBanner }) => ($hasBanner ? "5px" : "0px")};
`;

export const FlexibleRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`;

export const ArticleGroupRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid var(--grey200);
  margin-bottom: 8px;
  padding: 16px;
`;

export const CarouselImage = styled(FixaImage)<{
  $rotation: number;
  $clickable?: boolean;
  $variant?: "desktop" | "mobile";
}>`
  width: ${({ $variant }) => ($variant === "desktop" ? "20vw" : "100%")};
  max-width: ${({ $variant }) =>
    $variant === "mobile" ? "calc(100vw - 32px)" : "none"};
  height: auto;
  max-height: ${({ $variant }) => ($variant === "mobile" ? "50vh" : "none")};
  aspect-ratio: 3 / 4;
  object-fit: contain;
  transform: rotate(${({ $rotation }) => $rotation}deg);
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
`;

export const ThumbnailImage = styled(FixaImage)<{
  $rotation: number;
  $selected?: boolean;
}>`
  width: 52px;
  height: 52px;
  object-fit: contain;
  transform: rotate(${({ $rotation }) => $rotation}deg);
  cursor: pointer;
  padding: 0px 8px;
  border: ${({ $selected }) =>
    $selected ? "2px solid #111" : "2px solid transparent"};
  border-radius: 4px;
`;

export const PaddedContainer = styled.div<{ $py: string; $px: string }>`
  padding: ${({ $py }) => $py} ${({ $px }) => $px};
`;

export const ListItemImageContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
`;

export const MediaImagesListItemWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;

export const ListItemImage = styled(FixaImage)<{
  $rotation: number;
  $isMain?: boolean;
}>`
  width: 73px;
  height: 73px;
  border-radius: 5px;
  object-fit: cover;
  transform: rotate(${({ $rotation }) => $rotation}deg);
  border: ${({ $isMain = false }) => ($isMain ? "4px solid #0058A3" : "none")};
`;

export const ArticleListItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 8px;

  .image--fallback {
    padding: 0px 4px 0px 0px !important;
  }
`;
export const ArticleListItemImage = styled(FixaImage)`
  width: 50px;
  height: 50px;
  object-fit: cover;
  padding-right: 4px;
'
`;

export const GreyBoxWithText = styled.div`
  width: 50px;
  height: 50px;
  background-color: var(--grey100);
  text-align: center;
  vertical-align: middle;
  line-height: 50px;
`;
export const FurnitureSetWrapperInGroup = styled(FurnitureSetWrapper)`
  margin-right: 5px;
`;
export const SimpleContainer = styled.div<{ $direction: "column" | "row" }>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction};
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 24px;
`;

export const FlexContainer = styled.div<{ $direction: "column" | "row" }>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction};
  width: 100%;
  gap: 8px;
  padding: 0px 24px;
`;

export const fontSizeMap = {
  small: "12px",
  medium: "14px",
  large: "16px",
  "x-large": "18px",
};

export const TextStyle = styled.div<{
  $bold: boolean;
  $italic: boolean;
  $color: string;
  $size: keyof typeof fontSizeMap;
}>`
  font-size: ${({ $size }) => fontSizeMap[$size]};
  font-weight: ${({ $bold }) => ($bold ? "700" : "400")};
  font-style: ${({ $italic }) => ($italic ? "italic" : "normal")};
  color: var(--${({ $color }) => $color});
`;

// Medias InputPopup styles
export const InputPopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  background-color: var(--white);
  padding: 0 24px;
`;

export const InputPopupContentBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StickyButtonContainer = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: var(--white);
  gap: 4px;
  padding-bottom: 8px;
`;

export const ZoomStaticButtonContainer = styled.div`
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GreyRow = styled.div`
  width: 100%;
  background-color: var(--grey100);
  display: flex;
  box-sizing: border-box;
  align-items: end;
  padding: 12px 24px;
`;

export const MediaListDesktop = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
`;

// 172px = scrollbar + margins between cards + padding in cards + borders around cards / 4
// 172 = (5 + 12 * 3 + 16 * 2 * 4 + 1 * 2 * 4) / 4
export const MediaListItemCardDesktop = styled.li`
  display: block;
  float: left;
  width: calc((100% - 172px) / 4);
  height: 361px;
  border: 1px solid;
  border-color: var(--grey200);
  padding: 16px;
  background-color: var(--white);
`;

export const FullSpaceAnchor = styled.a`
  display: block; /* important */
  width: 100%;
  height: 100%;
  text-decoration: none; /* optional */
  color: inherit; /* optional */
`;

export const ArticleListItemMobile = styled.div`
  border-top: 1px solid var(--grey200);
  padding: 16px;

  :last-child {
    border-bottom: 1px solid var(--grey200);
  }
`;

export const ArticleListItemCardDesktop = styled.li`
  display: block;
  float: left;
  width: calc((100% - 172px) / 4);
  height: 144px;
  border: 1px solid;
  border-color: var(--grey200);
  padding: 16px;
`;

export const CardFrame = styled.div`
  width: calc(100% - 48px);
  height: calc(100% - 48px);
  margin: 0px 24px;
  background: var(--white);
`;

export const FullLine = styled.hr<{
  margin?: string;
}>`
  width: 100%;
  margin: ${({ margin }) => (margin ? margin : "12")}px 0px;
  height: 1px;
  background-color: var(--grey200);
`;

export const GreySpace = styled.div`
  height: 24px;
  background-color: var(--grey100);
`;

export const WhiteSpace = styled.div<{
  height?: string;
}>`
  height: ${({ height }) => (height ? height : "24")}px;
  background-color: var(--white);
`;

export const ZoomControlContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ZoomControlPercentageBox = styled.div`
  width: 58px;
  height: 48px;
  border-radius: 4px;
  border: 1px solid var(--grey200);
  background-color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ZoomableImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const StyledZoomableImage = styled(FixaImage).attrs<{
  $rotation: number;
  $zoomScale: number;
  $panX: number;
  $panY: number;
}>(({ $rotation, $zoomScale, $panX, $panY }) => ({
  style: {
    transform: `rotate(${$rotation}deg) translate(${$panX}px, ${$panY}px) scale(${$zoomScale})`,
  },
}))<{
  $rotation: number;
  $zoomScale: number;
  $panX: number;
  $panY: number;
}>`
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin: 0 auto;
  transition: transform 0.2s ease-out;
  user-select: none;
`;
